export const PLACEMENT_OPTIONS = [
  { value: "top", label: "Top — Hero carousel" },
  { value: "middle", label: "Middle — Between sections" },
  { value: "bottom", label: "Bottom — Pre-footer strip" },
];

export const SIZE_OPTIONS = [
  { value: "half", label: "Half width" },
  { value: "full", label: "Full width" },
];

export const SURFACE_OPTIONS = [
  { value: "both", label: "Both (App + Web)" },
  { value: "app", label: "App only" },
  { value: "web", label: "Web only" },
];

export const PLACEMENT_VALUES = PLACEMENT_OPTIONS.map((o) => o.value);
export const SIZE_VALUES = SIZE_OPTIONS.map((o) => o.value);
export const SURFACE_VALUES = SURFACE_OPTIONS.map((o) => o.value);

export const S3_BANNERS_FOLDER = "banners";

// Whitelist of image MIME types accepted for banner uploads. SVG is intentionally
// excluded — banners render on the public storefront, and an SVG can embed <script>.
// All formats here are raster and universally supported by storefront browsers.
export const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/avif",
];

export const ALLOWED_IMAGE_ACCEPT = ALLOWED_IMAGE_TYPES.join(",");
